/**
 * LUMA JEWELLERY — Filter Interactions
 * File: assets/luma-filter-interactions.js
 */
(function () {
  'use strict';

  window.lumaFilterSort = function (selectEl) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', selectEl.value);
    window.location.href = url.toString();
  };

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('luma-filter-form');
    if (!form) return;

    // Loading state on any filter change
    form.querySelectorAll('.luma-filter-input').forEach(function (input) {
      input.addEventListener('change', function () {
        form.classList.add('luma-filters--loading');
      });
    });

    // Price range apply button
    var priceApply = form.querySelector('.luma-filters__price-apply');
    if (priceApply) {
      priceApply.addEventListener('click', function (e) {
        e.preventDefault();
        form.classList.add('luma-filters--loading');
        form.submit();
      });
    }

    // Price range enter key
    form.querySelectorAll('.luma-filters__price-input').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); form.submit(); }
      });
    });

    // ── Hover label — shows next to group label instead of above icon ──────
    // Covers: metal swatches, diamond shapes, style icons
    form.querySelectorAll(
      '.luma-swatch-wrap, .luma-shape'
    ).forEach(function (el) {
      var group = el.closest('.luma-group');
      if (!group) return;
      var hoverVal = group.querySelector('.luma-group__hover-val');
      if (!hoverVal) return;

      el.addEventListener('mouseenter', function () {
        // Get label from the hidden span, or fall back to title attribute
        var labelEl = el.querySelector('.luma-shape__label');
        var text = labelEl ? labelEl.textContent.trim() : (el.getAttribute('title') || '');
        if (text) hoverVal.textContent = text;
      });

      el.addEventListener('mouseleave', function () {
        hoverVal.textContent = '';
      });
    });

    // Scroll to products after filtering
    if (window.location.search.includes('filter.') || window.location.search.includes('sort_by')) {
      var grid = document.querySelector('.product-grid, #product-grid, [data-product-grid]');
      if (grid) setTimeout(function () { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
    }
  });
})();
